// extracted by mini-css-extract-plugin
export var deleteModal = "_q7-0";